const selectors = {
  productContainer: document.querySelector('[data-product-container]')
};

function tplProductRollbar(context, err, extra) {
  if (!window.Rollbar) return;
  try {
    const message =
      err && typeof err === 'object' && err.message
        ? String(err.message)
        : typeof err === 'string'
          ? err
          : 'TemplateProduct error';
    Rollbar.error(message, err instanceof Error ? err : { detail: err }, {
      context: 'TemplateProduct.' + context,
      ...(extra && typeof extra === 'object' ? extra : {}),
    });
  } catch (_) {}
}

function wrapTemplateProductPrototype(Ctor, className) {
  if (!Ctor || !Ctor.prototype) return;
  const proto = Ctor.prototype;
  Object.getOwnPropertyNames(proto).forEach((name) => {
    if (name === 'constructor') return;
    const desc = Object.getOwnPropertyDescriptor(proto, name);
    if (!desc || typeof desc.value !== 'function') return;
    const original = desc.value;
    proto[name] = function tplProductWrapped(...args) {
      try {
        const result = original.apply(this, args);
        if (result != null && typeof result.then === 'function') {
          return result.catch((e) => {
            tplProductRollbar(`${className}.${name}`, e);
            return Promise.reject(e);
          });
        }
        return result;
      } catch (e) {
        tplProductRollbar(`${className}.${name}`, e);
        throw e;
      }
    };
  });
}

class TemplateProductJS {
  constructor() {
    try {
    this.abortController = undefined;
    this.pendingRequestUrl = null;
    this.container = selectors.productContainer;

    var manufacturerDetailValue = this.getQueryStringValue('manufacturerdetail');
    if (manufacturerDetailValue) {
      var manufacturerDetail = manufacturerDetailValue.split(' ^ ');
      var oemHeaderElement = document.querySelector('.oem-header-labeldec');
      if (oemHeaderElement && manufacturerDetail.length >= 2) {
        oemHeaderElement.innerHTML = `<span>${manufacturerDetail[1]}</span><span>${manufacturerDetail[0]}</span>`;
      }
    }

    // Product page option change event to update dynamic data
    eventBus.subscribe(PUB_SUB_EVENTS.optionChange, (eventData) => {
      const { target, selectedOptionsId } = eventData.data;
      this.handleOptionValueChange(target, selectedOptionsId);
    });



    const inventoryWrapper = document.querySelector('.product-inventory-wrapper');
    if (inventoryWrapper?.querySelector('[data-expected-date]')) {
      this.expectedshipdate = inventoryWrapper.querySelector('[data-expected-date]');
      const isExpectedDate =
        this.expectedshipdate.getAttribute('data-expected-date') === 'true';
      const targetDate = Utility.resolveShipDate({
        inputDate: this.expectedshipdate.getAttribute('data-inputdate') || '',
        isExpectedDate,
        businessDays: this.expectedshipdate.getAttribute('data-businessdays'),
        holidays: this.expectedshipdate.getAttribute('data-holidays'),
        checkavail: this.expectedshipdate.getAttribute('data-checkavail'),
      });

      if (isExpectedDate) {
        this.expectedshipdate.innerHTML = `Expected Ship Date:  <span class="fw-normal">${targetDate}</span>`;
      } else if (
        Utility.shouldShowShipDateInsteadOfMessage({
          inputDate: this.expectedshipdate.getAttribute('data-inputdate') || '',
        })
      ) {
        const dateMarkup = `<span class="fw-normal">${targetDate}</span>`;
        this.expectedshipdate.innerHTML = Utility.isShipTomorrowWeekend()
          ? `Expected Ship Date:  ${dateMarkup}`
          : dateMarkup;
      }

      const productContainer = inventoryWrapper.closest('[data-product-container]');
      const shipDateInput =
        productContainer?.querySelector('[data-shipdate-input]') ||
        document.querySelector('[data-shipdate-input]');
      if (shipDateInput && targetDate) {
        shipDateInput.value = targetDate;
      }
    }
    } catch (e) {
      tplProductRollbar('TemplateProductJS.constructor', e);
    }
  }

  formatDate(date) {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  }

  getQueryStringValue(param) {
    var url = window.location.href;
    // alert(url);
    var regex = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
    var result = regex.exec(url);
    
    if (result === null) {
      return null; // Parameter not found
    } else {
      return decodeURIComponent(result[1].replace(/\+/g, ' ')); // Decode and replace '+' with space
    }
  }
  

  addPreProcessCallback(callback) {
    this.preProcessHtmlCallbacks.push(callback);
  }

  handleOptionValueChange(target, selectedOptionsId){
    if (!this.container.contains(target)) return;

    const productUrl = target.dataset.productUrl || this.container.pendingRequestUrl || this.container.dataset.url;
    this.pendingRequestUrl = productUrl;
    const swapProduct = this.container.dataset.url !== productUrl;
    const fetchFullPage = this.container.dataset.updateUrl === 'true' && swapProduct;

    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionsId, fetchFullPage),
      targetId: target.id,
      callback: swapProduct
        ? this.handleSwapProduct(productUrl, fetchFullPage)
        : this.handleUpdateProductInfo(productUrl),
    });
  }

  renderProductInfo({ requestUrl, targetId, callback }) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        this.pendingRequestUrl = null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        document.querySelector(`#${targetId}`)?.focus();
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        } else {
          tplProductRollbar('renderProductInfo.fetch', error);
          console.error(error);
        }
      });
  }

  handleSwapProduct(productUrl, updateFullPage) {
    
  }

  handleUpdateProductInfo(productUrl){
    return (html) => {
      
      const productId = this.container.dataset.product;
      const updateSourceFromDestination = (id) => {
        const source = html.querySelector(id);
        const destination = this.container.querySelector(id);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.classList.remove('d-none');
        }else{
          destination?.classList.add('d-none')
        }
      };

      updateSourceFromDestination(`#Inventory-${productId}`);
      updateSourceFromDestination(`#Sku-${productId}`);
      updateSourceFromDestination(`#Quantity-${productId}`);
      updateSourceFromDestination(`#Volume-discount-${productId}`);
    }
  }

  buildRequestUrlWithParams(url, optionValues, fetchFullPage = false) {
    const params = [];
    !fetchFullPage && params.push(`section_id=${this.container.dataset.section}`);
    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }
    return `${url}?${params.join('&')}`;
  }
}

wrapTemplateProductPrototype(TemplateProductJS, 'TemplateProductJS');

try {
  if (typeof TemplateProductJS !== 'undefined') {
    new TemplateProductJS();
  }
} catch (e) {
  tplProductRollbar('bootstrap', e);
}

/* OEM view more */ 
/* make sire OEM view more convert to show less if clicked again */

const viewMoreBtn = document.querySelector('[data-viewmore]');
const viewMoreText = document.querySelector('[data-viewmore-text]');
if (viewMoreBtn) {
  viewMoreBtn.addEventListener('click', function (e) {
    e.preventDefault();
    try {
      const viewMoreLabel = viewMoreText ? viewMoreText.innerHTML.trim() : '';
      const lowercontent = viewMoreLabel.toLowerCase();
      if (lowercontent === 'show less') {
        const oemTable = document.querySelector('.oem-table');
        const hiddenRows = oemTable ? oemTable.querySelectorAll('tr.view-more') : [];
        if (hiddenRows.length > 0) {
          hiddenRows.forEach(row => row.classList.add('d-none'));
          if (viewMoreText) viewMoreText.innerHTML = 'VIEW MORE';
        }
        const oemTableContainer = document.querySelector('[data-oem-table-container]');
        if (oemTableContainer) {
          const header = document.querySelector('.section-header');
          const headerHeight = header ? header.offsetHeight : (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pe-header-height'), 10) || 0);
          const targetTop = oemTableContainer.getBoundingClientRect().top + window.pageYOffset;
          const scrollTop = targetTop - headerHeight;
          window.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
        }
        return;
      }
      const oemTable = document.querySelector('.oem-table');
      const hiddenRows = oemTable ? oemTable.querySelectorAll('tr.view-more') : [];
      if (hiddenRows.length > 0) {
        hiddenRows.forEach(row => row.classList.remove('d-none'));
        if (viewMoreText) viewMoreText.innerHTML = 'Show LESS';
      }
    } catch (err) {
      tplProductRollbar('viewMoreBtn.click', err);
      throw err;
    }
  });
}
